import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

// Link groups extracted to module scope so React's reconciler sees a stable
// reference on every render instead of newly-allocated arrays (avoids
// unnecessary <FooterCol /> re-renders when Footer itself re-renders).
const PLATFORM_LINKS = [
  { to: "/browse", label: "Browse" },
  { to: "/merch", label: "Merch" },
  { to: "/promotions", label: "Promote" },
];
const COMPANY_LINKS = [
  { to: "/manual", label: "User Manual" },
  { to: "/roadmap", label: "Roadmap" },
  { to: "/releases", label: "Release Notes" },
  { to: "/contact", label: "Contact" },
  { to: "/register", label: "Become an artist" },
];
const LEGAL_LINKS = [
  { to: "/terms", label: "Terms" },
  { to: "/privacy", label: "Privacy" },
  { to: "/dmca", label: "DMCA" },
];

export default function Footer() {
  const y = new Date().getFullYear();
  return (
    <footer className="border-t border-[#2A2A2A] bg-black mt-20 pb-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 grid gap-8 md:grid-cols-[2fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark size={32} />
            <span className="font-display font-black text-xl tracking-tighter">Melo<span className="text-[#FF4500]">Craft</span></span>
          </div>
          <p className="font-mono text-xs text-gray-500 mt-4 leading-relaxed max-w-sm">
            The music marketplace where artists keep 100%. Songs $0.99 · Albums $15 · Free radio for everyone.
          </p>
        </div>
        <FooterCol title="Platform" links={PLATFORM_LINKS} />
        <FooterCol title="Company" links={COMPANY_LINKS} />
        <FooterCol title="Legal" links={LEGAL_LINKS} />
      </div>
      <div className="border-t border-[#2A2A2A]">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-4 font-mono text-[10px] uppercase tracking-widest text-gray-600 flex justify-between flex-wrap gap-2">
          <span>© {y} MeloCraft · All rights reserved</span>
          <span>Craft your sound · Sell it direct</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF4500] mb-3">{title}</div>
      <ul className="space-y-2 font-mono text-xs">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="text-gray-400 hover:text-white transition-colors">{l.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
